<template>
    <div>
        <v-container>
            <div class="d-flex justify-space-between mt-10 mb-5">
                <h2 class="mb-3">Operators</h2>

                <v-btn class="mr-2 mt-1"
                       @click="onOpenCreateOperatorModal"
                       color="secondary">
                    <v-icon class="mr-1">mdi-account-circle</v-icon> Create Operator
                </v-btn>

            </div>
            <v-text-field v-model="searchText"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          class="mb-3"
                          hide-details></v-text-field>

            <v-data-table :headers="headers"
                          :items="operators"
                          must-sort
                          item-key="key"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :server-items-length="totalItems"
                          :loading="isBusy"
                          :items-per-page.sync="pageSize"
                          :footer-props="{'items-per-page-options': [25, 50, 100, 100]}"
                          :page.sync="pageNo"
                          class="elevation-1">

                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon v-bind="attrs"
                                   @click="onOpenEditOperatorModal(item.id)"
                                   v-on="on" color="lighten-2">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit Operator</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon v-bind="attrs"
                                   @click="onOpenOperatorMenuModal(item.id)"
                                   v-on="on" color="lighten-2">
                                <v-icon>mdi-menu-open</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit Operator Menu Access</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon v-bind="attrs"
                                   @click="onOpenOperatorBrandModal(item.id)"
                                   v-on="on" color="lighten-2">
                                <v-icon>mdi-account-lock</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit Operator Brands</span>
                    </v-tooltip>
                </template>

                <template v-slot:item.domain="{ item }">
                    <v-chip small v-for="dom in item.domain.split(';')" :key="dom" class="ma-2">
                        {{dom}}
                    </v-chip>
                </template>

                <template v-slot:item.dateRegistered="{ item }">
                    {{ item.dateRegistered | DateTime }}
                </template>

                <template v-slot:item.isInternal="{ item }">
                    {{ item.isInternal | YesNo }}
                </template>

                <template v-slot:item.isSensitiveModeEnabled="{ item }">
                    {{ item.isSensitiveModeEnabled | EnabledDisabled }}
                </template>

            </v-data-table>
        </v-container>

        <sweet-modal :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" ref="createUpdateOperatorModal" blocking>
            <v-form v-model="isFormValid" ref="operatorForm">
                <v-container>
                    <h3 class="mb-3">
                        {{action}} Operator
                    </h3>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="operator.name"
                                          :rules="nameRules"
                                          :counter="250"
                                          label="Operator Name"
                                          required></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="10">
                                    <v-text-field v-model="domainName"
                                                  :counter="250"
                                                  label="New Domain Name"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="mt-4">
                                    <v-btn color="default" @click="onAddNewDomain">
                                        Add
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <div v-if="operator.domain" class="text-left">
                                <v-chip v-for="dom in operator.domain.split(';')" :key="dom" class="ma-2" close @click:close="onRemoveDomain(dom)">
                                    {{dom}}
                                </v-chip>
                            </div>

                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" align="right">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        <v-checkbox v-model="operator.isInternal"
                                                    label="Is Internal"></v-checkbox>
                                    </div>
                                </template>
                                <span>Used to determine if the operator is internal</span>
                            </v-tooltip>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="right">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        <v-checkbox v-model="operator.isSensitiveModeEnabled"
                                                    label="Is Sensitive Mode Enabled"></v-checkbox>
                                    </div>
                                </template>
                                <span>Used to determine if data will be obfuscated before being displayed to the operator</span>
                            </v-tooltip>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="right">
                            <v-btn depressed
                                   v-if="action === 'Edit'"
                                   :disabled="!isFormValid"
                                   align="right"
                                   @click="onUpdateOperator"
                                   class="black--text mt-10 font-bold"
                                   color="primary">
                                Save
                            </v-btn>

                            <v-btn depressed
                                   v-if="action === 'Create'"
                                   @click="onCreateOperator"
                                   :disabled="!isFormValid"
                                   align="right"
                                   class="black--text mt-10 font-bold"
                                   color="primary">
                                Create
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </sweet-modal>
        <operator-brand-modal ref="operatorBrandModal"></operator-brand-modal>
        <operator-menu-modal ref="operatorMenuModal"></operator-menu-modal>
    </div>
</template>
<script>
    import OperatorService from "../../services/operatorService.js"
    import OperatorBrandModal from "../../components/modal/OperatorBrandModal.vue"
    import OperatorMenuModal from "../../components/modal/OperatorMenuModal.vue"
    export default {
        name: 'Operators',
        components: {
            OperatorBrandModal,
            OperatorMenuModal
        },
        data: function () {
            return {
                isBusy: true,
                email: "",
                searchTimer: null,
                domainName: "",
                brandName: "",
                searchText: "",
                pageNo: 1,
                pageSize: 10,
                accessToken: "",
                totalItems: 0,
                sortBy: 'name',
                sortDesc: false,
                headers: [
                    {
                        text: 'Name',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {
                        text: 'Domain',
                        align: 'start',
                        sortable: true,
                        value: 'domain',
                    },
                    {
                        text: 'Date Registered',
                        align: 'start',
                        sortable: true,
                        value: 'dateRegistered',
                    },
                    {
                        text: 'Is Internal',
                        align: 'start',
                        sortable: true,
                        value: 'isInternal',
                    },
                    {
                        text: 'Sensitive Mode',
                        align: 'start',
                        sortable: true,
                        value: 'isSensitiveModeEnabled',
                    },
                    { text: '', value: 'actions', align: 'end', sortable: false },
                ],
                operators: [],
                operator: {
                    name: "",
                    domain: "",
                    isSensitiveModeEnabled: false,
                    isInternal: false
                },
                isFormValid: false,
                action: "Create",
                nameRules: [
                    v => !!v || 'Operator name is required',
                    v => v?.length <= 250 || 'Operator ame must be less than 250 characters'
                ]
            }
        },
        watch: {
            pageNo: function () {
                this.searchOperators();
            },
            pageSize: function () {
                this.searchOperators();
            },
            searchText: function () {
                let self = this;
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(function () {
                    self.searchOperators();
                }, 1000);
            },
            sortBy: function () {
                this.searchOperators();
            },
            sortDesc: function () {
                this.searchOperators();
            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.searchOperators();
            },
            async searchOperators() {
                this.isBusy = true;
                var sortBy = this.sortBy ? "name" : this.sortBy;
                var sortDesc = this.sortDesc === false ? "ASCENDING" : "DESCENDING"
                const result = await OperatorService.searchOperators(this.accessToken, this.searchText, this.pageNo, this.pageSize, sortBy, sortDesc);
                this.operators = result.data.map((item, key) => ({ ...item, key }));
                this.totalItems = result.count;
                this.isBusy = false;
            },
            async onUpdateOperator() {
                this.isBusy = true;

                const result = await OperatorService.updateOperator(this.operator, this.accessToken);

                if (result) {
                    this.$refs.createUpdateOperatorModal.close();
                    this.searchOperators();
                }

                this.isBusy = false;

            },
            async onCreateOperator() {
                this.isBusy = true;

                const result = await OperatorService.createOperator(this.operator, this.accessToken);

                if (result) {
                    this.$refs.createUpdateOperatorModal.close();
                    this.searchOperators();
                }

                this.isBusy = false;

            },
            onOpenCreateOperatorModal() {
                this.action = "Create";
                this.domainName = "";
                this.operator = {
                    name: "",
                    domain: "",
                    isSensitiveModeEnabled: false,
                    isInternal: false
                };
                this.$refs.createUpdateOperatorModal.open();
                this.$refs.operatorForm.resetValidation();
            },
            async onOpenEditOperatorModal(id) {
                this.isBusy = true;
                this.action = "Edit";

                const result = await OperatorService.getOperatorById(id, this.accessToken);

                this.operator = result;

                this.$refs.createUpdateOperatorModal.open();
                this.isBusy = false;
                this.$refs.operatorForm.resetValidation();
            },
            onAddNewDomain() {

                //clear whitespace
                this.domainName = this.domainName.replace(' ', '');

                if (this.operator.domain) {
                    this.operator.domain += `;${this.domainName}`;
                }
                else {
                    this.operator.domain = this.domainName;
                }

                this.domainName = "";

                this.$refs.operatorForm.resetValidation();
            },
            onAddNewBrand() {

                if (!this.operator.operatorBrands.some(brand => brand.name.toLowerCase() === this.brandName.toLowerCase())) {
                    this.operator.operatorBrands.push({ name: this.brandName });
                }

                this.brandName = "";

                this.$refs.operatorForm.resetValidation();
            },
            onRemoveDomain(domain) {
                this.operator.domain = this.operator.domain.replace(`${domain};`, "").replace(`;${domain}`, "").replace(domain, "");
            },
            onOpenOperatorBrandModal(operatorId) {
                this.$refs.operatorBrandModal.open(operatorId);
            },
            onOpenOperatorMenuModal(operatorId) {
                this.$refs.operatorMenuModal.open(operatorId);
            }
        },
        created() {
            this.setup();
        }
    }
</script>
